import service from '@/services/types/canton'

export const namespaced = true

export const state = () => ({
  list: [],
  filterList: []
})

export const mutations = {
  LIST: (state, objs) => (state.list = [...state.list, ...objs])
}

export const actions = {
  list: ({ commit, state }, value) => {
    if (value) {
      const canton = state.list.filter(c => c.idProvincia === value)

      if (!canton.length)
        return service.list(value).then(result => {
          console.log('Cantones desde api 🥵 ', result.length)

          commit('LIST', result)

          return result
        })
      else {
        console.log('cantones en store ⏩')

        return canton
      }
    }
  }
}
